
// Basics

global.id = function id (n) {
  return n;
};

global.log = function log () {
  console.log.apply(console, arguments);
  return arguments[0];
};

global.vhToPx = function vhToPx (vh) {
  return vh/100 * window.innerHeight;
};

/*
global.isMobile = function isMobile () {
  return window.innerWidth < 768;
};

global.scrollTo = function scrollTo (offset, speed) {
  $('html, body').animate({ scrollTop: offset }, speed);
};

global.hasReach = function hasReach (elPos) {
  return $(window).scrollTop() >= elPos;
};

global.inArea = function inArea (startPos, stopPos) {
  return hasReach(startPos) && !hasReach(stopPos);
};

global.px = function px (n) {
  return Math.round(n) + 'px';
};

global.vwToPx = function vhToPx (vw) {
  return vw/100 * window.innerWidth;
}
*/
global.isdef = function isdef (thing) {
  return typeof thing !== 'undefined';
}
/*
global.int = function int (n) {
  return parseFloat(n, 10);
};


// Arrays

global.head = function head (xs) {
  return xs.length ? xs[0] : null;
};
*/
global.last = function last (list) {
  return list.length ? list[list.length - 1] : null;
}
/*
global.contains = function contains (list, needle) {
  return -1 < list.indexOf(needle);
}


// Functional

global.dot = function dot (prop) {
  return function (thing) {
    return thing[prop];
  };
};
*/
global.invoke = function invoke (...args) {
  return function _invoke (λ) {
    λ.apply(null, args);
  }
}

global.clone = function clone (obj) {
  return Object.assign({}, obj);
};

global.cloneMerge = function cloneMerge (a, b) {
  return Object.assign(Object.assign({}, a), b);
};
/*
global.compose = function compose (f, g) {
  return function () {
    g(f.apply(null, arguments));
  };
};


// Strings/Formatting

global.formatMoney = function formatMoney (value) {
  if (typeof value === 'number') return value;
  return '$' + parseFloat(value, 10).toFixed(2);
}

*/

global.convertBool = function convertBool (value) {
  return value === "true"  ? true :
         value === "false" ? false :
         value;
}

global.percent = function percent (p, preserveSpace) {
  var pc = Math.round(p * 100);
  return (preserveSpace && pc < 100 ? ' ' : '') + pc + '%';
}


// Maths

global.lerp = function lerp (a, b, t) {
  return a + (b - a) * t;
}

global.floor = Math.floor;
global.round = Math.round;

global.randomFrom = function randomFrom (xs) {
  return xs[ floor(Math.random() * xs.length) ];
}


// Time

global.delay = function delay (t, λ) {
  var n = setTimeout(λ, t * 1000);
  return { cancel: function () { clearTimeout(n); } };
};

global.defer = function defer (λ) {
  return setTimeout(λ, 0);
};


// Dom

global.findInside = function findInside (el) {
  return function (sel) {
    return $(sel, el);
  };
};

global.whichKey = function whichKey (code, λ) {
  return function _whichKey (event) {
    if (event.which === code) {
      λ(event);
    }
  };
};

/*
global.removeSelf = function removeSelf () {
  $(this).remove();
}
*/

// Events

global.swallow = function swallow (λ) {
  return function _swallow (event) {
    event.preventDefault();
    event.stopPropagation();
    λ.apply(this, arguments);
  };
}

global.throttle = function throttle (fn, wait) {
  var time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  }
}

global.jqe = function jqe (λ) {
  return function _jqe (event) {
    λ(this, event);
  };
};


// XHR

global.loadImg = function loadImg (src, λ) {
  var i = new Image();
  i.onload  = function () { λ(i, true);  };
  i.onerror = function () { λ(i, false); };
  i.src = src;
};

global.loadVideo = function loadVideo (src, λ) {
  var req = new XMLHttpRequest();
  req.open('GET', src, true);
  req.responseType = 'blob';

  req.onload = function () {
    if (this.status === 200) {
      λ(URL.createObjectURL(this.response), true);
    } else {
      λ(null, false);
    }
  };

  req.onerror = function() { λ(null, false); }
  req.send();
};

